import { render, staticRenderFns } from "./AppThird.vue?vue&type=template&id=37ae5ad5&scoped=true"
import script from "./AppThird.vue?vue&type=script&lang=js"
export * from "./AppThird.vue?vue&type=script&lang=js"
import style0 from "./AppThird.vue?vue&type=style&index=0&id=37ae5ad5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae5ad5",
  null
  
)

export default component.exports